import { render, staticRenderFns } from "./1vVcard.vue?vue&type=template&id=500bf5da&scoped=true&"
import script from "./1vVcard.vue?vue&type=script&lang=js&"
export * from "./1vVcard.vue?vue&type=script&lang=js&"
import style0 from "./1vVcard.vue?vue&type=style&index=0&id=500bf5da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bf5da",
  null
  
)

export default component.exports